import React, { useCallback } from "react";
import { createSelector } from "reselect";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import SimpleMapMarker from "../SimpleMapMarker/SimpleMapMarker";

// Info marker configuration
import { configUnitTitle } from "views/Map/MapPageConfig";

// helpers
import { iconType } from "helpers/getIcon";

// actions creators
import { REMOVE_SELECTED_UNIT, SET_SELECTED_UNITS } from "redux/ducks/mapPage";

// Selectors
const unitsFiltered = createSelector(
  (state) => state.map.units,
  (state) => state.map.search,
  (state) => state.map.typesValues,
  (units, search, typesValues) => {
    if (typesValues.length) {
      return units
        .filter((item) =>
          item.number.toLowerCase().includes(search.toLowerCase())
        )
        .filter((item) => typesValues.includes(item.type));
    }
    return units.filter((item) =>
      item.number.toLowerCase().includes(search.toLowerCase())
    );
  }
);

const UnitsMarkers = ({ color }) => {
  const dispatch = useDispatch();
  const addSelectedUnit = useCallback(
    (id) => dispatch({ type: SET_SELECTED_UNITS, payload: id }),
    [dispatch]
  );
  const removeSelectedUnit = useCallback(
    (id) => dispatch({ type: REMOVE_SELECTED_UNIT, payload: id }),
    [dispatch]
  );
  const units = useSelector(unitsFiltered);
  const selectedUnits = useSelector(
    (state) => state.map.selectedUnits,
    shallowEqual
  );

  const isOpen = (number) => {
    return selectedUnits.includes(number);
  };
  return (
    <React.Fragment>
      {units.map((item, index) => {
        return (
          <SimpleMapMarker
            key={`${item.number}i${index}`}
            item={item}
            isOpen={isOpen(item["number"])}
            onSelect={
              !selectedUnits.includes(item.number)
                ? addSelectedUnit
                : removeSelectedUnit
            }
            idMarker="number"
            lat={item.location.lat}
            lng={item.location.lon}
            config={configUnitTitle}
            onCloseInfo={removeSelectedUnit}
            icon={`${iconType(item.type, item.last_login)}`}
          />
        );
      })}
    </React.Fragment>
  );
};

export default React.memo(UnitsMarkers);
